
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageToDataUrlModule } from "ngx-image2dataurl";

//Component
import { FileUploaderComponent } from './file-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ImageToDataUrlModule,
  ],
  declarations: [ FileUploaderComponent ],
  exports: [ FileUploaderComponent ]
})

export class FileUploaderModule { }